export default "__VITE_ASSET__dOQtnEZg__"